// src/pages/categorias/EliminarCategoria.js
import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function EliminarCategoria(props) {
	const { categoria, cancelar, mostrar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = () => {
		eliminar(categoria?.id)
	}

	useEffect(() => {
		// Se puede añadir lógica adicional al montar/desmontar el componente
	}, [categoria])

	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Categoría</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar la categoría <strong>{categoria?.nombre}</strong>. Esta acción no se puede deshacer.
				</Alert>
				{categoria?.subcategorias && categoria.subcategorias.length > 0 && (
					<Alert variant="warning">
						<i className="fa fa-exclamation-triangle me-2"></i>
						Esta categoría tiene {categoria.subcategorias.length} subcategoría(s). Al eliminarla, todas sus subcategorías también serán eliminadas.
					</Alert>
				)}
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarCategoria